import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MandatesListComponent } from "./mandates-list.component";
import { TranslateModule } from "@ngx-translate/core";
import { TableModule } from '@valg-shared/components/table/table.module';
import { ValgMessageBarModule } from '@valg-shared/components/valg-message-bar/valg-message-bar.module';
import { ResultSummaryModule } from '@shared/components/result-summary/result-summary.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        TableModule,
        ValgMessageBarModule,
        ResultSummaryModule
    ],
  declarations: [
    MandatesListComponent
  ],
  exports: [
    MandatesListComponent
  ]
})
export class MandatesListModule {}
